import './layout.scss';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useContext, useEffect, Suspense, lazy } from 'react';
import { AuthContext } from '../../context/AuthContext';

const LazyNavbar = lazy(() => import('../../components/navbar/Navbar'));
const LazyFooter = lazy(() => import('../../components/footer/Footer'));

function Layout() {
  const location = useLocation();

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  return (
    <div className="layout">
      <Suspense fallback={<div>Loading...</div>}>
        <div className="navbar">
          <LazyNavbar />
        </div>
      </Suspense>
      <div className="content">
        <Outlet />
        <Suspense fallback={<div>Loading...</div>}>
          <LazyFooter />
        </Suspense>
      </div>
    </div>
  );
}

function RequireAuth() {
  const { currentUser } = useContext(AuthContext);
  return currentUser ? <Layout /> : <Navigate to="/login" />;
}

export { Layout, RequireAuth };
